import React from 'react';
import { View, Platform } from 'react-native';
import { Text } from 'tamagui';
import * as Animatable from 'react-native-animatable';
import LottieView from '@utils/lottieAnimation';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import styles from '@stylesheet';

interface ComingSoonProps {
  title?: string;
  subtitle?: string;
  message?: string;
  showAnimation?: boolean;
  animationSource?: any;
  containerStyle?: any;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = "Coming Soon",
  subtitle = "We're working on something amazing",
  message = "This feature is currently under development and will be available soon. Stay tuned for updates!",
  showAnimation = true,
  animationSource,
  containerStyle
}) => {
  const theme = themeSelector();

  return (
    <View style={[styles.comingSoonContainer, containerStyle]}>
      <Animatable.View 
        animation="fadeInUp"
        duration={800}
        delay={200}
        style={[
          styles.comingSoonContent,
          { backgroundColor: theme ? 'rgba(255,255,255,0.95)' : 'rgba(20,20,20,0.95)' }
        ]}
      >
        {showAnimation && (
          <Animatable.View 
            animation="bounceIn"
            duration={1000}
            delay={400}
            style={styles.comingSoonAnimationContainer}
          >
            {animationSource ? (
              <LottieView
                source={animationSource}
                autoPlay
                loop
                style={styles.comingSoonAnimation}
              />
            ) : (
              <View style={[
                styles.comingSoonPlaceholder,
                { backgroundColor: theme ? 'rgba(90,192,234,0.1)' : 'rgba(90,192,234,0.2)' }
              ]}>
                <Text style={[
                  styles.comingSoonPlaceholderIcon,
                  { color: theme ? 'rgb(90,192,234)' : '#60a5fa' }
                ]}>
                  🚀
                </Text>
              </View>
            )}
          </Animatable.View>
        )}

        <Animatable.View 
          animation="fadeInUp"
          duration={600}
          delay={600}
          style={styles.comingSoonTextContainer}
        >
          <Text style={[
            styles.comingSoonTitle,
            { color: theme ? '#1e293b' : '#f1f5f9' }
          ]}>
            {title}
          </Text>

          <Text style={[
            styles.comingSoonSubtitle,
            { color: theme ? '#475569' : '#cbd5e1' }
          ]}>
            {subtitle}
          </Text>

          <View style={[
            styles.comingSoonDivider,
            { backgroundColor: theme ? 'rgba(90,192,234,0.3)' : 'rgba(90,192,234,0.5)' }
          ]} />

          <Text style={[
            styles.comingSoonMessage,
            { color: theme ? '#64748b' : '#94a3b8' }
          ]}>
            {message}
          </Text>
        </Animatable.View>

        <Animatable.View 
          animation="pulse"
          iterationCount="infinite"
          duration={2000}
          delay={800}
          style={styles.comingSoonProgressContainer}
        >
          <View style={[
            styles.comingSoonProgressBar,
            { backgroundColor: theme ? 'rgba(90,192,234,0.1)' : 'rgba(90,192,234,0.2)' }
          ]}>
            <Animatable.View
              animation={{
                0: { width: '0%' },
                1: { width: '75%' }
              }}
              duration={2000}
              delay={1000}
              style={[
                styles.comingSoonProgressFill,
                { backgroundColor: theme ? 'rgb(90,192,234)' : '#60a5fa' }
              ]}
            />
          </View>
          <Text style={[
            styles.comingSoonProgressText,
            { color: theme ? '#64748b' : '#94a3b8' }
          ]}>
            Development in progress...
          </Text>
        </Animatable.View>
      </Animatable.View>
    </View>
  );
};

export default ComingSoon;
